import { CardHeader as UnstyledCardHeader, styled } from "@mui/material";

import { Column } from "@citrine/atoms/layout";

const CATALYST_HEADER_BACKGROUND_COLOR = "rgba(245, 245, 245, 0.95)"; // theme.palette.grey[100]

export const Container = styled(Column)(({ theme }) => ({
  background: CATALYST_HEADER_BACKGROUND_COLOR,
  gap: theme.spacing(1),
  padding: theme.spacing(2),
}));

export const CardHeader = styled(UnstyledCardHeader)(({ theme }) => ({
  gap: theme.spacing(2),
  padding: 0,

  "& .MuiCardHeader-action": {
    margin: 0,
  },
}));
